import { getDatadogInstance } from '@cw-elements/analytics-provider';

import type { EventParams } from '@/hooks';

export type ErrorContext = Record<string, EventParams[string]>;

/**
 * Reports a handled error to Datadog RUM so failures that are caught and
 * recovered in the UI — e.g. a micro-frontend that fails to load and falls back
 * to a degraded view — stay traceable instead of disappearing silently.
 *
 * The `context` is attached to the RUM error so the failure can be filtered and
 * alerted on (e.g. by `feature`). Same value constraints as Amplitude/Datadog
 * elsewhere — `string | number | boolean` only, and never PII.
 *
 * A no-op until the analytics provider has initialized RUM.
 *
 * @example
 * trackDatadogError(error, { feature: 'topbar-navigation', degraded: true });
 */
const trackDatadogError = (error: unknown, context?: ErrorContext) => {
  getDatadogInstance()?.addError(error, context);
};

export default trackDatadogError;
